module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Gd-Ha 后背.c32b1cc0.png";